import { render } from "./RecoverPassword.vue?vue&type=template&id=edc2d40e&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import "./RecoverPassword.vue?vue&type=style&index=0&id=edc2d40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc2d40e"]])

export default __exports__